<div class="license-panel__card">
  <div class="license-panel__card--content" #content>
    <h2 *ngIf="data?.header" class="license-panel__header">{{ data.header }}</h2>
    <p *ngIf="data?.subHeader" class="license-panel__subheader">{{ data.subHeader }}</p>
    <p *ngIf="data?.price" class="license-panel__price">{{ data.price }}</p>
    <p *ngIf="data?.terms" class="license-panel__terms">{{ data.terms }}</p>
    <div *ngIf="data?.link" class="license-panel__link">
      <app-bg-button [data]="data.link" [buttonColor]="data.linkColor"></app-bg-button>
    </div>
  </div>
  <div class="license-panel__description license-panel__description--{{data.modifierForCssClass}}" #description>
    <div class="license-panel__triangle license-panel__triangle--{{data.modifierForCssClass}}"></div>
    <div [innerHTML]="data.description"></div>
  </div>
  <div class="license-panel__info">
    <ul *ngFor="let item of data.informationArray; let i = index;" [@info]="infoState">
      <li>
        <div [innerHTML]="item.information"></div>
      </li>
    </ul>
    <div *ngIf="data.informationArray?.length" class="license-panel__info--arrow" (click)="toggleInfoState(0)">
      <div class="license-panel__info--arrow-line" [@arrow]="infoState"></div>
    </div>
  </div>
</div>